import { categories } from '@/mocks/motionComics';

const quickLinks = [
  { label: '首页', href: '#top' },
  { label: '全彩漫画', href: '#featured' },
  { label: '热门榜单', href: '#ranking' },
  { label: '追更动态', href: '#latest' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300/60 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="flex items-center gap-2.5" aria-label="韩漫映画 首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-xl text-foreground-50">韩漫映画</span>
                <span className="text-[10px] tracking-[0.2em] text-secondary-500">HANMOTION</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-xs leading-6 text-foreground-400">
              专注韩国动态漫画在线播放平台，全彩有声、特效拉满、配音版同步更新，点开即播，陪你把好故事一集不落追到底。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-semibold text-foreground-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-xs text-foreground-300 transition-colors hover:text-primary-400">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.name}>
                  <a href="#categories" className="text-xs text-foreground-300 transition-colors hover:text-primary-400">
                    {c.name} · {c.count} 部
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-xs text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-fill text-primary-400" aria-hidden="true"></i>
                contact@hanmotion.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-fill text-primary-400" aria-hidden="true"></i>
                每日 9:00 - 22:00
              </li>
            </ul>
            <div className="mt-5 flex gap-2">
              {['ri-weibo-line', 'ri-twitter-x-line', 'ri-bilibili-fill', 'ri-qq-line'].map((icon, i) => (
                <a
                  key={i}
                  href="#contact"
                  aria-label="社交媒体链接"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/60 text-foreground-300 transition-colors hover:border-primary-400 hover:text-primary-400"
                >
                  <i className={`${icon} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">© 2026 韩漫映画 HANMOTION · 用心陪伴每一部好故事</p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#about" className="transition-colors hover:text-primary-400">关于我们</a>
            <a href="#faq" className="transition-colors hover:text-primary-400">常见问题</a>
            <a href="#contact" className="transition-colors hover:text-primary-400">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}